import { createParser, system } from "@styled-system/core";
var config = {
  listStyleType: true,
  listStylePosition: true,
  listStylePos: {
    property: "listStylePosition"
  },
  listStyleImage: true,
  listStyleImg: {
    property: "listStyleImage"
  }
};
export var list = system(config);
export var listParser = createParser(config);